import { get } from "lodash";
import { useTranslation } from "react-i18next";
import { MdOutlineInsertComment } from "react-icons/md";
import Form from "shared/components/Form";
import FormField from "shared/components/FormField";
import Input from "shared/components/Input";
import { NAME_SPACES } from "shared/locales/constants";
import { SUBSCRIPTION_FORM_KEYS } from "utils/constants";

const Information = ({ bindField, initialValues, setPercent, isFieldRequired }) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.BROKER.CONTRACT);
  const INFORMATION = t(
    "SUBSCRIPTION.FORM.ADDITIONAL_INFORMATION.INFORMATION",
    { returnObjects: true },
  );

  const acceptTermsPath = "project.contact.fields.acceptTerms";
  const acceptTermsLabel =
    get(
      INFORMATION,
      `ACCEPT_TERMS_${get(initialValues, "insurancePlan.category")}`,
    ) || INFORMATION.ACCEPT_TERMS_A;
  const acceptTermsField = bindField(acceptTermsPath, {
    label: acceptTermsLabel,
    onChange: () => setPercent(initialValues),
    onBlur: () => setPercent(initialValues),
  });

  const honorDeclarationPath = "project.contact.fields.honorDeclaration";
  const honorDeclarationField = bindField(honorDeclarationPath, {
    label: INFORMATION.HONOR_DECLARATION,
    onChange: () => setPercent(initialValues),
    onBlur: () => setPercent(initialValues),
  });

  const digitalConsentPath = "project.contact.fields.digitalConsent";
  const digitalConsentField = bindField(digitalConsentPath, {
    label: INFORMATION.DIGITAL_CONSENT,
    onChange: () => setPercent(initialValues),
    onBlur: () => setPercent(initialValues),
  });

  const earlyExecConsentPath = "project.contact.fields.earlyExecConsent";
  const earlyExecConsentField = bindField(earlyExecConsentPath, {
    label: INFORMATION.EARLY_EXEC_CONSENT,
    onChange: () => setPercent(initialValues),
    onBlur: () => setPercent(initialValues),
  });

  const commentPath = "project.fields.info.comment";
  const commentField = bindField(commentPath, {
    label: INFORMATION.COMMENT,
    onChange: () => setPercent(initialValues),
    onBlur: () => setPercent(initialValues),
  });

  const DEFAULT_QUESTIONS = [
    acceptTermsPath,
    honorDeclarationPath,
    digitalConsentPath,
    earlyExecConsentPath,
  ];

  const QUESTIONS = {
    [acceptTermsPath]: (
      <FormField
        path={acceptTermsField.path}
        label={acceptTermsField.label}
        required={acceptTermsField.required}
        disabled={acceptTermsField.disabled}
      >
        {(field) => (
          <Input
            type="switch"
            label={acceptTermsLabel}
            checked={get(initialValues, acceptTermsPath) === true}
            {...field}
            onChange={acceptTermsField.onChange}
            onBlur={acceptTermsField.onBlur}
          />
        )}
      </FormField>
    ),
    [honorDeclarationPath]: (
      <FormField
        path={honorDeclarationField.path}
        label={honorDeclarationField.label}
        required={honorDeclarationField.required}
        disabled={honorDeclarationField.disabled}
      >
        {(field) => (
          <Input
            type="switch"
            label={INFORMATION.HONOR_DECLARATION}
            checked={get(initialValues, honorDeclarationPath) === true}
            {...field}
            onChange={honorDeclarationField.onChange}
            onBlur={honorDeclarationField.onBlur}
          />
        )}
      </FormField>
    ),
    [digitalConsentPath]: (
      <FormField
        path={digitalConsentField.path}
        label={digitalConsentField.label}
        required={digitalConsentField.required}
        disabled={digitalConsentField.disabled}
      >
        {(field) => (
          <Input
            type="switch"
            label={INFORMATION.DIGITAL_CONSENT}
            checked={get(initialValues, digitalConsentPath) === true}
            {...field}
            onChange={digitalConsentField.onChange}
            onBlur={digitalConsentField.onBlur}
          />
        )}
      </FormField>
    ),
    [earlyExecConsentPath]: (
      <FormField
        path={earlyExecConsentField.path}
        label={earlyExecConsentField.label}
        required={earlyExecConsentField.required}
        disabled={earlyExecConsentField.disabled}
      >
        {(field) => (
          <Input
            type="switch"
            label={INFORMATION.EARLY_EXEC_CONSENT}
            checked={get(initialValues, earlyExecConsentPath) === true}
            {...field}
            onChange={earlyExecConsentField.onChange}
            onBlur={earlyExecConsentField.onBlur}
          />
        )}
      </FormField>
    ),
  };

  return (
    <div
      className="subscription-form--wrapper"
      id={`${SUBSCRIPTION_FORM_KEYS.ADDITIONAL_INFORMATION.INFORMATION}-section`}
    >
      <Form type="vertical" title={INFORMATION.LMF_TITLE}>
        <div className="grid--1">
          {DEFAULT_QUESTIONS.map((info) => (
            <div key={info}>{QUESTIONS[info]}</div>
          ))}
          <FormField
            path={commentField.path}
            label={commentField.label}
            required={commentField.required}
            disabled={commentField.disabled}
          >
            {(field) => (
              <Input
                type="textarea"
                label={INFORMATION.COMMENT}
                placeholder={INFORMATION.COMMENT}
                icon={<MdOutlineInsertComment size={16} />}
                defaultValue={commentField.defaultValue}
                {...field}
                onChange={commentField.onChange}
                onBlur={commentField.onBlur}
                autoSize={{ minRows: 2, maxRows: 10 }}
                optional={!isFieldRequired(commentPath)}
              />
            )}
          </FormField>
        </div>
      </Form>
    </div>
  );
};

export default Information;
